import { QueryKey } from 'react-query';
import { serviceKey } from '../service';
import { IO } from '../types';

export const queryEndpointKeys = {
  tasksList: [...serviceKey, 'tasks'],
  taskById: [...serviceKey, 'task-by-id'],
  widgetTasksList: [...serviceKey, 'widget-tasks'],
};

export const queryRequestKeys = {
  tasksList: (req: IO.GetTaskList['input']): QueryKey => [...queryEndpointKeys.tasksList, req],
  widgetTasksList: (req: IO.GetWidgetTaskList['input']): QueryKey => [
    ...queryEndpointKeys.widgetTasksList,
    req.status,
    req.timeWindow,
    req.locationId,
  ],
  taskById: (req: IO.GetTaskList['input']): QueryKey => [...queryEndpointKeys.taskById, req],
  privateAssignees: (req: IO.GetPhoneAuthorizedAssignees['input']): QueryKey => [
    ...serviceKey,
    'private-assignees',
    req,
  ],
  suggestTaskDetails: (req: IO.SuggestTaskDetails['input']): QueryKey => [
    ...serviceKey,
    'suggest-task-details',
    req.context,
    req.locationId,
    req.patientName,
  ],
  surroundingMessages: (req: IO.UseSuggestTaskDetailsWithContextInput): QueryKey => [
    ...serviceKey,
    'surrounding-messages',
    req.sourceId,
    req.threadId,
    req.locationId,
  ],
};
